import { Outlet } from "react-router-dom";
import Topbar from "./Topbar";
import { Toaster } from "@/components/ui/sonner";

export default function AppShell({ children }) {
  return (
    <div className="min-h-screen bg-background">
      <Topbar />

      <main className="hd-content overflow-x-hidden" data-testid="app-main">
        {children || <Outlet />}
      </main>

      <Toaster
        position="top-right"
        richColors
        closeButton
        duration={4000}
      />
    </div>
  );
}
